<ng-container *ngIf="loaded">

  <div class="flex flex-col h-full">

    <div class="underlined flex flex-row justify-between items-center p-16 gap-3 w-full" style="background: #f1f5f9;">
      <div class="flex flex-col">
          <small>Customer:</small>
          <h3 class="m-0 max-w-[200px] truncate elipsis pb-2">{{ model.form10a.formCustomer.name }}</h3>
          <small class="hide-on-small">Contact Number:</small>
          <small class="show-on-small">Contact No:</small>
          <h3 class="m-0">{{ model.contactNumber }}</h3>
      </div>

      <div class="flex flex-col">
          <small>Booked In:</small>
          <h3 class="m-0 pb-2">{{ model.form10a.dateReceived | date: "d/M/YYYY" }}</h3> <!-- model.date = createdUTC -->
          <small>Due Date:</small>
          <h3 class="m-0">{{ model.loadcell.dueDate | date: "d/M/YYYY" }}</h3>
      </div>

      <div *ngIf="!isBasic" class="flex flex-col items-center">
        <small>Status:</small>

        <mat-form-field class="w-full fuse-mat-dense mt-2" [subscriptSizing]="'dynamic'">
          <mat-select
            panelClass="max-w-none max-h-128"
            [value]="model.loadcell?.status"
            (selectionChange)="updateStatus($event)"
          >
            <mat-select-trigger><small>{{getStatus(model.loadcell?.status)}}</small></mat-select-trigger>
            <mat-option *ngFor="let status of statusList" [value]="status.value" class="leading-[1]">
              <small>{{ status.name }}</small>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="flex flex-col items-center">
        <div class="flex flex-row items-center">
          <mat-icon
            [class]="{
              critical: model.loadcell.priorityStatus == priority.Overdue,
              red: model.loadcell.priorityStatus == priority.Priority,
              amber: model.loadcell.priorityStatus == priority.Normal
            }"
            class="flag small icon-15 material-icons-outlined p-4"
            [svgIcon]="'googlefonts:circle-flag-outline'"
            ></mat-icon
          >
        </div>
        <h3 *ngIf="!model.loadcell?.overdueBy" class="ml-0 mt-10">
          {{ getPriorityName(model.loadcell.priorityStatus) }}
        </h3>
        <h3 *ngIf="model.loadcell?.overdueBy" class="mb-0 mt-10 font-red text-center">
          {{ "Due " + model.loadcell?.overdueBy + " hours ago" }}
        </h3>
      </div>

      <div *ngIf="isAdmin" class="flex flex-col items-center">
        <small>User:</small>

        <mat-form-field class="w-full fuse-mat-dense mt-2" [subscriptSizing]="'dynamic'">
          <mat-select
            panelClass="max-w-none max-h-128"
            [value]="model.inspectedBy"
            (selectionChange)="updateEmployee($event)"
          >
            <mat-select-trigger><small>{{model.inspectedBy}}</small></mat-select-trigger>
            <mat-option *ngFor="let employee of employees" [value]="employee.firstName + ' ' + employee.lastName" class="leading-[1]">
              <small>{{ employee.firstName }} {{ employee.lastName }}</small>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="flex flex-col items-center">
        <small>Print QR:</small>
        <mat-icon
          class="function-button material-icons-outlined mt-2 cursor-pointer"
          (click)="printQRPopup()"
          >qr_code</mat-icon
        >
      </div>

      <div class="flex flex-col items-center">
        <small>Bulk QR:</small>
        <mat-icon
          class="function-button material-icons-outlined mt-2 cursor-pointer"
          [svgIcon]="'custom:qr-bulk'"
          (click)="bulkPrintQRPopup()"
        ></mat-icon>
      </div>

      <div *ngIf="isAdmin" class="flex flex-col items-center">
        <small>Edit Job:</small>
        <mat-icon
          class="function-button material-icons-outlined mt-2 cursor-pointer"
          (click)="navigateToForm10A()"
          >edit</mat-icon
        >
      </div>

      <div *ngIf="isSuperAdmin" class="flex flex-col items-center">
        <small>Delete Job:</small>
        <mat-icon
          class="function-button material-icons-outlined mt-2 cursor-pointer"
          (click)="archiveLoadcell()"
        >delete</mat-icon>
      </div>

      <mat-icon class="material-icons-outlined mb-auto cursor-pointer" (click)="close()">close</mat-icon>
    </div>


    <div class="flex flex-col w-full grow min-w-0 sm:inset-0 sm:overflow-hidden">
      <mat-drawer-container class="text-black flex-auto sm:h-full">

        <!-- Drawer -->
        <mat-drawer
            class="sm:w-80 dark:bg-gray-900"
            [autoFocus]="false"
            [mode]="drawerMode"
            [opened]="drawerOpened"
            #drawer>
            <!-- Header -->
            <!-- <div class="flex items-center justify-between m-8 mr-6 sm:my-10"> -->
                <!-- Title -->
                <!-- <div class="text-4xl  tracking-tight leading-none">Settings</div> -->
                <!-- Close button -->
                <div class="lg:hidden">
                    <button
                        mat-icon-button
                        (click)="drawer.close()">
                        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                    </button>
                </div>
            <!-- </div> -->
            <!-- Panel links -->
            <div class="flex flex-col divide-y border-t border-b">
                <ng-container *ngFor="let panel of panels; trackBy: trackByFn">
                    <div
                        class="flex px-7 py-5 cursor-pointer"
                        [ngClass]="{'hover:bg-gray-100 dark:hover:bg-hover': !selectedTab || selectedTab !== panel.id,
                                    'bg-primary-50 dark:bg-hover': selectedTab && selectedTab === panel.id}"
                        (click)="selectTab(panel.id)">
                        <mat-icon
                            [ngClass]="{'text-hint': !selectedTab || selectedTab !== panel.id,
                                        'text-primary dark:text-primary-500': selectedTab && selectedTab === panel.id}"
                            [svgIcon]="panel.icon"></mat-icon>
                        <div class="ml-3">
                            <div
                                class="font-medium leading-6"
                                [ngClass]="{'text-primary dark:text-primary-500': selectedTab && selectedTab === panel.id}">
                                {{panel.title}}
                            </div>
                            <div class="mt-0.5 text-secondary">
                                {{panel.description}}
                            </div>
                        </div>
                    </div>
                </ng-container>


                <div class="absolute bottom-0 p-2 pl-6 w-full">

                  <div class="flex flex-col">
                    <p class="font-14 m-0 mb-1"><strong>Inspected by:</strong> {{ model.inspectedBy }}</p>
                    <p class="font-14 m-0"><strong>Date:</strong> {{ model.date | date: "d/M/YYYY" }}</p>
                  </div>

                </div>

              <!-- <div
                class="flex flex-row justify-between items-center mx-16 my-8"
              >
                <div class="flex flex-row">
                  <p class="font-14 m-0 mx-8">Inspected by:</p>
                  <p class="font-14 m-0">{{ model.inspectedBy }}</p>
                </div>

                <div class="flex flex-row">
                  <p class="font-14 m-0">Date:</p>
                  <p class="font-14 m-0 mx-8">{{ model.date | date: "d/M/YYYY" }}</p>
                </div>
              </div> -->
            </div>
        </mat-drawer>

        <!-- Drawer content -->
        <mat-drawer-content class="flex flex-col py-6 bg-card">

          <!-- Drawer toggle -->
          <button
              class="lg:hidden ml-2 -mt-2"
              mat-icon-button
              (click)="drawer.toggle()">
              <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
          </button>

          <div class="tab-container flex flex-row justify-start">

            <!-- Comments -->
            <div *ngIf="selectedTab == Tab.Comments" class="flex flex-col w-full">
              <mat-label class="w-full text-xl mb-6 px-32">Comments</mat-label>

              <div class="flex flex-col px-32">
                <label>General Notes</label>
                <mat-form-field
                  class="w-full mt-2"
                  [subscriptSizing]="'dynamic'">
                  <textarea
                    matInput
                    (change)="updateComments($event)"
                    [value]="model.loadcell.comments"
                    [rows]="3"
                    cdkTextareaAutosize
                    [cdkAutosizeMinRows]="2">
                  </textarea>
                </mat-form-field>

                <div class="w-full border-t my-6"></div>
                <label>User Comments</label>
                <app-comments
                    class="w-full"
                    titleClass="hidden"
                    [comments]="genericComments"
                    [parentId]="model.loadcell.loadcellId"
                    ($commentAdded)="addComment($event)"
                    ($commentChanged)="updateComment($event)"
                    ($commentDeleted)="removeComment($event)">
                </app-comments>

              </div>
            </div>

            <!-- Customer -->
            <div *ngIf="selectedTab == Tab.Customer" class="flex flex-col w-full px-32">
              <mat-label class="w-full text-xl">Customer</mat-label>

              <div class="flex button-container justify-end -mt-8 mb-6">
                <button
                  *ngIf="isAdmin"
                  mat-flat-button
                  color="primary"
                  (click)="openQuotationDialog()"
                >
                  Quotation
                </button>
              </div>
              <div class="flex flex-col">
                <p class="font-14 m-0">Invoice Address:</p>
                <mat-form-field class="w-45 py-4">
                  <mat-select
                    [value]="getSelectedInvoiceAddress()"
                    (selectionChange)="updateInvoiceAddress($event)"
                  >
                    <mat-option
                      *ngFor="let customerLocation of model.customerLocationOptions"
                      [value]="customerLocation"
                    >
                      <span class="whitespace-nowrap">{{ customerLocation?.location }}</span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <p class="font-14 m-0">Dispatch Address:</p>
                <mat-form-field class="w-45 py-4">
                  <mat-select
                    [value]="getSelectedDispatchAddress()"
                    (selectionChange)="updateDispatchAddress($event)"
                  >
                    <mat-option
                      *ngFor="let customerLocation of model.customerLocationOptions"
                      [value]="customerLocation"
                    >
                      <span class="whitespace-nowrap">{{ customerLocation?.location }}</span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <p class="font-14 m-0">Quote Contact:</p>
                <mat-form-field class="w-45 py-4">
                  <mat-select
                    [value]="getSelectedQuoteContact()"
                    (selectionChange)="updateQuoteContact($event)"
                  >
                    <mat-option
                      *ngFor="let customerContact of model.customerContactOptions"
                      [value]="customerContact"
                    >
                      <span class="whitespace-nowrap">{{ customerContact?.name }}</span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="pt-6"></div>
            </div>

            <!-- Preliminary Report & Quotation -->
            <div *ngIf="selectedTab == Tab.Preliminary" class="flex flex-col w-full">
              <mat-label class="w-full text-xl px-32">Preliminary Report & Quotation</mat-label>
              <div class="flex button-container justify-end pr-32 -mt-8 mb-6">
                <button
                  mat-flat-button
                  color="primary"
                  class="mr-16"
                  (click)="openExaminationReportDialog()"
                >
                  Examination Report
                </button>
                <div class="flex flex-col text-right">
                  <button
                    *ngIf="isAdmin"
                    mat-flat-button
                    color="primary"
                    (click)="openQuotationDialog()"
                  >
                    Quotation
                  </button>
                  <p *ngIf="model?.form10a?.quote?.dateEmailed">
                    Quote sent: {{model?.form10a?.quote?.dateEmailed | date:'dd/MM/yyyy'}}
                  </p>
                </div>
              </div>

              <div class="flex flex-col gap-4 mx-16">
                <div class="flex flex-col md:flex-row justify-between gap-4 md:gap-8 mx-16">

                  <!-- Details-->
                  <div class="flex flex-col md:w-[50%]">
                    <div
                      *ngIf="!isAdmin"
                      class="flex flex-row"
                    >
                      <p class="info-title font-14 m-0">Customer Ref:</p>
                      <p class="font-14 ml-8 m-0">
                        {{ model?.loadcell?.customerRef ?? "" }}
                      </p>
                    </div>
                    <div
                      *ngIf="isAdmin"
                      class="flex flex-row items-center"
                    >
                      <p class="info-title font-14 m-0">Customer Ref:</p>
                      <mat-form-field class="ml-8 m-0 fuse-mat-dense" [subscriptSizing]="'dynamic'">
                        <input
                          matInput
                          type="text"
                          [value]="model?.loadcell?.customerRef ?? ''"
                          (change)="updateCustomerRef($event)"
                        />
                      </mat-form-field>
                    </div>
                    <div class="flex flex-row">
                      <p class="info-title font-14 m-0">Serial Number:</p>
                      <p class="font-14 ml-8 m-0">
                        {{ model.form10a.formSerialNumber.name ?? "" }}
                      </p>
                    </div>
                    <div class="flex flex-row">
                      <p class="info-title font-14 m-0">Job Number:</p>
                      <p class="font-14 ml-8 m-0">{{ model.loadcell.loadcellId }}</p>
                      <!-- <p class="font-14 ml-8 m-0">{{ model.loadcell.bookingRef }}</p> -->
                    </div>
                    <div class="flex flex-row">
                      <p class="info-title font-14 m-0">Quote:</p>
                      <p class="font-14 ml-8 m-0">
                        {{
                          model.form10a?.quote?.quoteId
                            ? "R" + model.form10a?.quote?.quoteId
                            : ""
                        }}
                      </p>
                    </div>
                    <div class="flex flex-row">
                      <p class="info-title font-14 m-0">PO:</p>
                      <p class="font-14 ml-8 m-0">{{ model.form10a.purchaseOrder }}</p>
                    </div>


                    <!-- <div class="flex flex-col mx-16"> -->
                      <div class="flex flex-row">
                        <p class="info-title font-14 m-0">Load Cell Description:</p>
                        <p class="font-14 ml-8 m-0">
                          {{ model.form10a.typeNote }}
                        </p>
                      </div>
                      <div class="flex flex-row">
                        <p class="info-title font-14 m-0">Loadcell type:</p>
                        <p class="font-14 ml-8 m-0">
                          {{ model.form10a.loadCellType?.name }}
                        </p>
                      </div>
                      <div class="flex flex-row">
                        <p class="info-title font-14 m-0">Plant ID:</p>
                        <p class="font-14 ml-8 m-0">{{ model.form10a.plantId }}</p>
                      </div>
                      <div class="flex flex-row">
                        <p class="info-title font-14 m-0">Manufacturer:</p>
                        <p class="font-14 ml-8 m-0">{{ model.form10a.manufacturer }}</p>
                      </div>
                      <div class="flex flex-row">
                        <p class="info-title font-14 m-0">WLL:</p>
                        <p class="font-14 ml-8 m-0">{{ model.form10a.workingLoadLimit }}</p>
                      </div>
                      <div class="flex flex-row">
                        <p class="info-title font-14 m-0">Booking ref:</p>
                        <p class="font-14 ml-8 m-0">{{ model.form10a.bookingRef }}</p>
                      </div>
                      <div class="flex flex-row">
                        <p class="info-title font-14 m-0">Location:</p>
                        <p class="font-14 ml-8 m-0">{{ model.form10a.location?.name }}</p>
                      </div>
                    <!-- </div> -->
                  </div>

                  <!-- Latest Comment -->
                  <div *ngIf="genericComments?.length" class=" md:w-[50%] md:mr-30 mb-8 md:mb-0">
                    <p class="info-title font-14 m-0">Latest Comment:</p>
                    <app-comments
                      class="w-full"
                      titleClass="hidden"
                      [comments]="genericComments"
                      [parentId]="model.loadcell.loadcellId"
                      [showLatestCommentOnly]="true"
                      [readOnly]="true"
                      ($commentAdded)="addComment($event)"
                      ($commentChanged)="updateComment($event)"
                      ($commentDeleted)="removeComment($event)">
                    </app-comments>
                  </div>

                </div>

                <!-- Images -->
                <div *ngIf="this.files?.length > 0">
                  <div class="slideshow-container justify-around">
                    <a class="prev" (click)="showSlides(-1)">
                      <mat-icon>arrow_back</mat-icon>
                    </a>
                    <ng-container *ngFor="let url of this.urls; let i = index">
                      <div class="mySlides fade relative" [ngClass]="{ hide: i > 2 }">
                        <img [src]="url" />
                        <mat-icon
                          class="bg-white text-[var(--dlm-red)] rounded-full icon-size-6 absolute cursor-pointer top-[5px] right-[5px]"
                          [svgIcon]="'heroicons_solid:x-circle'"
                          matTooltip="Delete Image"
                          (click)="deleteImage(i)">
                        </mat-icon>
                        <mat-icon
                          class="bg-white text-[var(--dlm-green)] rounded-full icon-size-6 absolute cursor-pointer bottom-[5px] right-[5px]"
                          [svgIcon]="'mat_solid:download_for_offline'"
                          matTooltip="Download Image"
                          (click)="downloadImage(i)">
                        </mat-icon>
                      </div>
                    </ng-container>

                    <a class="next" (click)="showSlides(1)">
                      <mat-icon>arrow_forward</mat-icon>
                    </a>
                  </div>
                  <br />
                </div>
              </div>

              <div
                class="flex flex-row underlined justify-between items-center mx-32"
                (click)="toggleCollapseOtherItems()"
              >
                <h4 class="cursor-pointer py-8 m-0">Other items with equipment:</h4>
                <mat-icon *ngIf="otherItemsExpanded">expand_more</mat-icon>
                <mat-icon *ngIf="!otherItemsExpanded">chevron_right</mat-icon>
              </div>
              <div *ngIf="otherItemsExpanded">
                <p class="font-14 mx-32 my-8">
                  {{ model.form10a.otherEquipmentItems }}
                </p>
              </div>

              <div
                class="flex flex-row underlined justify-between items-center mx-32"
                (click)="toggleCollapsePreliminary()"
              >
                <h4 class="cursor-pointer py-8 m-0">
                  Faults found on preliminary examination:
                </h4>
                <mat-icon *ngIf="preliminaryExpanded">expand_more</mat-icon>
                <mat-icon *ngIf="!preliminaryExpanded">chevron_right</mat-icon>
              </div>
              <ng-container *ngIf="preliminaryExpanded">
                <div
                  *ngFor="let fault of model.form10a.formExaminationFaults"
                  class="flex flex-row justify-between font-14 mx-32 my-4"
                >
                  <div class="flex flex-row items-center" style="flex-grow: 1">
                    <ng-container
                      *ngIf="
                        fault.examinationFaultOption.name != 'other' &&
                        fault.examinationFaultOption.name != 'null'
                      "
                    >
                      <p class="mb-0">{{ fault.examinationFaultOption.name }}</p>
                      <p class="mx-4 mb-0">-</p>
                    </ng-container>
                    <p class="mb-0" *ngIf="!isEditingFault(fault)">
                      {{ fault.comment }}
                    </p>
                    <mat-form-field *ngIf="isEditingFault(fault)" style="flex-grow: 1">
                      <input
                        matInput
                        [value]="editingFault?.comment"
                        (change)="editingFault.comment = $event.target.value"
                      />
                    </mat-form-field>
                  </div>
                  <mat-icon
                    *ngIf="
                      !isEditingFault(fault) &&
                      (isAdmin)
                    "
                    class="function-button material-icons-outlined mx-16 mt-16 cursor-pointer"
                    (click)="toggleEditFault(fault, false)"
                    >edit</mat-icon
                  >
                  <div class="flex flex-row" *ngIf="isEditingFault(fault)">
                    <mat-icon
                      *ngIf="isEditingFault(fault)"
                      class="function-button material-icons-outlined mx-16 mt-16 cursor-pointer"
                      (click)="toggleEditFault(fault, false)"
                      >close</mat-icon
                    >
                    <mat-icon
                      *ngIf="isEditingFault(fault)"
                      class="function-button material-icons-outlined mx-16 mt-16 cursor-pointer"
                      (click)="toggleEditFault(fault, true)"
                      >check</mat-icon
                    >
                  </div>
                </div>
              </ng-container>

              <div
                class="flex flex-row underlined justify-between items-center mx-32"
                (click)="toggleCollapseRectification()"
              >
                <h4 class="cursor-pointer py-8 m-0">
                  Rectification work required before second stage on testing /
                  calibration:
                </h4>
                <mat-icon *ngIf="rectificationExpanded">expand_more</mat-icon>
                <mat-icon *ngIf="!rectificationExpanded">chevron_right</mat-icon>
              </div>

              <ng-container *ngIf="rectificationExpanded">
                <div
                  *ngFor="let rectification of model.form10a.formRectificationWork"
                  class="flex flex-row justify-between font-14 mx-32 my-4"
                >
                  <div class="flex flex-row items-center">
                    <ng-container
                      *ngIf="
                        rectification.rectificationWorkOption?.name != 'other' &&
                        rectification.rectificationWorkOption?.name != 'null'
                      "
                    >
                      <p class="mb-0">
                        {{ rectification.rectificationWorkOption?.name }}
                      </p>
                      <p class="mx-4 mb-0">-</p>
                    </ng-container>
                    <p class="mb-0" *ngIf="!isEditingRectification(rectification)">
                      {{ rectification.comment }}
                    </p>
                    <mat-form-field *ngIf="isEditingRectification(rectification)">
                      <input
                        matInput
                        [value]="editingRectification?.comment"
                        (change)="editingRectification.comment = $event.target.value"
                      />
                    </mat-form-field>
                  </div>
                  <mat-icon
                    *ngIf="
                      !isEditingRectification(rectification) &&
                      (isAdmin)
                    "
                    class="function-button material-icons-outlined mx-16 mt-16 cursor-pointer"
                    (click)="toggleEditRectification(rectification, false)"
                    >edit</mat-icon
                  >
                  <div
                    class="flex flex-row"
                    *ngIf="isEditingRectification(rectification)"
                  >
                    <mat-icon
                      *ngIf="isEditingRectification(rectification)"
                      class="function-button material-icons-outlined mx-16 mt-16 cursor-pointer"
                      (click)="toggleEditRectification(rectification, false)"
                      >close</mat-icon
                    >
                    <mat-icon
                      *ngIf="isEditingRectification(rectification)"
                      class="function-button material-icons-outlined mx-16 mt-16 cursor-pointer"
                      (click)="toggleEditRectification(rectification, true)"
                      >check</mat-icon
                    >
                  </div>
                </div>
              </ng-container>

              <div
                class="flex flex-row justify-between items-center mx-16 my-16"
              >
                <div class="flex flex-col mx-16 w-50">
                  <div class="flex flex-row">
                    <p class="info-title font-14 m-0">Weight (kg):</p>
                    <p class="font-14 ml-8 m-0">{{ model.form10a.weight }}</p>
                  </div>
                  <div class="flex flex-row">
                    <p class="info-title font-14 m-0">Dimensions:</p>
                    <p class="font-14 ml-8 m-0">{{ model.form10a.dimensions }}</p>
                  </div>
                  <div class="flex flex-row">
                    <p class="info-title font-14 m-0">Packaging:</p>
                    <p class="font-14 ml-8 m-0">{{ model.form10a.packaging?.name }}</p>
                  </div>
                </div>
                <!-- right side -->
                <div class="flex flex-col mx-16 w-50">
                  <div class="flex flex-row justify-between w-75">
                    <p class="info-title font-14 m-0">Calibrated:</p>
                    <mat-icon class="check-mark" *ngIf="model.form10a.calibrated"
                      >check</mat-icon
                    >
                    <mat-icon class="cross" *ngIf="!model.form10a.calibrated"
                      >close</mat-icon
                    >
                  </div>
                  <div class="flex flex-row justify-between w-75">
                    <p class="info-title font-14 m-0">Repairs:</p>
                    <mat-icon class="check-mark" *ngIf="model.form10a.repairsComplete"
                      >check</mat-icon
                    >
                    <mat-icon class="cross" *ngIf="!model.form10a.repairsComplete"
                      >close</mat-icon
                    >
                  </div>
                  <div class="flex flex-row justify-between w-75">
                    <p class="info-title font-14 m-0">Pressure Test:</p>
                    <mat-icon class="check-mark" *ngIf="model.form10a.pressureTest"
                      >check</mat-icon
                    >
                    <mat-icon class="cross" *ngIf="!model.form10a.pressureTest"
                      >close</mat-icon
                    >
                  </div>
                </div>
              </div>

              <div class="flex flex-col mx-16 my-16">
                <div class="flex flex-row justify-start w-full mx-16 gap-4 md:gap-6 lg:gap-8">
                  <div class="flex flex-col gap-2">
                    <div class="flex flex-row">
                      <h4 class="font-14 m-0">Labour hours</h4>
                    </div>
                    <div class="flex flex-row">
                      <p class="font-14 m-0">
                        {{
                          model.form10a.labourHours *
                            model?.form10a?.labourCostSetting?.labourCost
                            | currency: "£":"symbol-narrow"
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="flex flex-col gap-2">
                    <div class="flex flex-row">
                      <h4 class="font-14 m-0">Calibration fee</h4>
                    </div>
                    <div
                      *ngIf="!isAdmin"
                      class="flex flex-row"
                    >
                      <p class="font-14 m-0">
                        {{
                          model.form10a.calibrationFee | currency: "£":"symbol-narrow"
                        }}
                      </p>
                    </div>
                    <div
                      *ngIf="isAdmin"
                      class="flex flex-row"
                    >
                      <mat-form-field class="w-full">
                        <input
                          matInput
                          type="text"
                          [value]="
                            model.form10a.calibrationFee | currency: '£':'symbol-narrow'
                          "
                          (change)="updateCalibrationFee($event)"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="flex flex-col gap-2">
                    <div class="flex flex-row">
                      <h4 class="font-14 m-0">Carriage</h4>
                    </div>
                    <div
                      *ngIf="!isAdmin"
                      class="flex flex-row"
                    >
                      <p class="font-14 m-0">
                        {{ model.form10a.carriage | currency: "£":"symbol-narrow" }}
                      </p>
                    </div>
                    <div
                      *ngIf="isAdmin"
                      class="flex flex-row"
                    >
                      <mat-form-field class="w-full">
                        <input
                          matInput
                          type="text"
                          [value]="
                            model.form10a.carriage | currency: '£':'symbol-narrow'
                          "
                          (change)="updateCarriageFee($event)"
                        />
                      </mat-form-field>
                    </div>

                    <div
                      *ngIf="isAdmin"
                      class="flex flex-row"
                    >
                      <div class="w-full">
                        <mat-radio-group
                          class="flex flex-col pr-16 mr-16"
                          style="gap: 8px"
                          [value]="model.form10a.carriageLocation"
                          (change)="updateCarriageLocation($event)"
                        >
                          <mat-radio-button [value]="CarriageLocation.MainlandUK"
                            >Mainland UK</mat-radio-button
                          >
                          <mat-radio-button [value]="CarriageLocation.International"
                            >International</mat-radio-button
                          >
                        </mat-radio-group>
                        <div class="flex flex-row" style="margin-top: 8px; margin-left: -2px;">
                          <mat-checkbox
                            [checked]="model.form10a.exWork"
                            (change)="updateExWork($event)"
                          >
                            Ex Work
                          </mat-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col gap-2">
                    <div class="flex flex-row">
                      <h4 class="font-14 m-0">Pressure Test Cost</h4>
                    </div>
                    <div
                      *ngIf="!isAdmin"
                      class="flex flex-row"
                    >
                      <p class="font-14 m-0">
                        {{
                          model.form10a.pressureTestCost | currency: "£":"symbol-narrow"
                        }}
                      </p>
                    </div>
                    <div
                      *ngIf="isAdmin"
                      class="flex flex-row"
                    >
                      <mat-form-field class="w-full">
                        <input
                          matInput
                          type="text"
                          [value]="
                            model.form10a.pressureTestCost
                              | currency: '£':'symbol-narrow'
                          "
                          (change)="updatePressureTestCost($event)"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="flex flex-col gap-2">
                    <div class="flex flex-row">
                      <h4 class="font-14 m-0">Third Party Calibration Client</h4>
                    </div>
                    <div
                      *ngIf="!isAdmin"
                      class="flex flex-row"
                    >
                      <p class="font-14 m-0">
                        {{ model.form10a.thirdPartyCalibrationClient }}
                      </p>
                    </div>
                    <div
                      *ngIf="isAdmin"
                      class="flex flex-row"
                    >
                      <mat-form-field class="w-full">
                        <input
                          matInput
                          type="text"
                          [value]="model.form10a.thirdPartyCalibrationClient"
                          (change)="updateThirdPartyCalibrationClient($event)"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="flex flex-col gap-2">
                    <div class="flex flex-row">
                      <h4 class="font-14 m-0">PO Number</h4>
                    </div>
                    <div
                      *ngIf="!isAdmin"
                      class="flex flex-row"
                    >
                      <p class="font-14 m-0">
                        {{ model.form10a.purchaseOrder }}
                      </p>
                    </div>
                    <div
                      *ngIf="isAdmin"
                      class="flex flex-row"
                    >
                      <mat-form-field class="w-full">
                        <input
                          matInput
                          type="text"
                          [value]="model.form10a.purchaseOrder"
                          (change)="updatePurchaseOrder($event)"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <!-- Parts -->
                <p *ngIf="model.form10a.formParts?.length > 0" class="info-title font-14 my-0 mx-16">Parts</p>
                <div
                  *ngIf="model.form10a.formParts?.length > 0"
                  class="flex flex-row justify-between items-center w-full mt-16 md:w-[50%] px-16 gap-4 md:gap-6 lg:gap-8"
                >
                  <div class="flex flex-col gap-2">
                    <div class="flex flex-row">
                      <h4 class="font-14 m-0">Part Name</h4>
                    </div>
                    <div
                      class="flex flex-col justify-center items-center"
                    >
                      <p
                        class="font-14 m-0"
                        *ngFor="let part of model.form10a.formParts"
                      >
                        {{ part.partOption?.number }}
                      </p>
                    </div>
                  </div>
                  <div class="flex flex-col gap-2">
                    <div class="flex flex-row">
                      <h4 class="font-14 m-0">Qty</h4>
                    </div>
                    <div
                      class="flex flex-col justify-center items-center"
                    >
                      <p
                        class="font-14 m-0"
                        *ngFor="let part of model.form10a.formParts"
                      >
                        {{ part.quantity }}
                      </p>
                    </div>
                  </div>
                  <div class="flex flex-col gap-2">
                    <div class="flex flex-row">
                      <h4 class="font-14 m-0">Price each</h4>
                    </div>
                    <div
                      class="flex flex-col justify-end items-center"
                    >
                      <p
                        class="font-14 m-0"
                        *ngFor="let part of model.form10a.formParts"
                      >
                        {{
                          (part.partOption?.number == "3rd Party"
                          ? part.cost
                          : part.partOption?.cost) *
                          (part.partOption.markup + 1) | currency: "£":"symbol-narrow"
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="model?.form10a?.formParts?.length > 0"
                  class="flex flex-row justify-between gap-8 items-center my-16 px-16 w-full md:w-[50%]"
                >
                  <span class="font-14">Parts Total:</span>
                  <span class="font-14">{{ calculatePartsTotal(model.form10a.formParts) | currency: "£":"symbol-narrow" }}</span>
                </div>
              </div>

              <div class="pt-6"></div>
            </div>

            <!-- Fault Report Details -->
            <div *ngIf="selectedTab == Tab.Fault" class="flex flex-col w-full">
              <mat-label class="w-full text-xl px-32">Fault Report Details</mat-label>
              <div class="flex button-container justify-end pr-32 -mt-8 mb-6">
                <button
                  *ngIf="isAdmin"
                  mat-flat-button
                  color="primary"
                  (click)="openQuotationDialog()"
                >
                  Quotation
                </button>
              </div>
              <div class="flex flex-row items-center mx-16 mb-16">
                <div class="flex flex-col mx-16">
                  <div class="flex flex-row">
                    <p class="bigger info-title font-14 m-0">MV Output at 0 Load:</p>
                    <p class="font-14 ml-8 m-0">{{ model.form10a.mvOutput }}</p>
                  </div>
                  <div class="flex flex-row">
                    <p class="bigger info-title font-14 m-0">Insulation resistance:</p>
                    <p class="font-14 ml-8 m-0">
                      {{ model.form10a.insulationResistance }}
                    </p>
                  </div>
                  <div class="flex flex-row">
                    <p class="bigger info-title font-14 m-0">Battery voltage:</p>
                    <p class="font-14 ml-8 m-0">{{ model.form10a.batteryVoltage }}</p>
                  </div>
                  <div class="flex flex-row">
                    <p class="bigger info-title font-14 m-0">Bridge resistance:</p>
                    <p class="font-14 ml-8 m-0">{{ model.form10a.bridgeResistance }}</p>
                  </div>
                </div>
              </div>

              <div class="flex flex-col mx-16 my-16">
                <div class="flex flex-col mx-16">
                  <div class="flex flex-row mb-8">
                    <p class="font-14 m-0 w-75">
                      Does output return to 0 after loading?
                    </p>
                    <mat-icon
                      class="check-mark"
                      *ngIf="model.form10a.returnToZero == YesNoNa.Yes"
                      >check</mat-icon
                    >
                    <mat-icon
                      class="cross"
                      *ngIf="model.form10a.returnToZero == YesNoNa.No"
                      >close</mat-icon
                    >
                    <h3 *ngIf="model.form10a.returnToZero == YesNoNa.NA">N/A</h3>
                  </div>
                  <div class="flex flex-row mb-8">
                    <p class="font-14 m-0 w-75">Is the loadcell's output repeatable</p>
                    <mat-icon
                      class="check-mark"
                      *ngIf="model.form10a.outputRepeatable == YesNoNa.Yes"
                      >check</mat-icon
                    >
                    <mat-icon
                      class="cross"
                      *ngIf="model.form10a.outputRepeatable == YesNoNa.No"
                      >close</mat-icon
                    >
                    <h3 *ngIf="model.form10a.outputRepeatable == YesNoNa.NA">N/A</h3>
                  </div>
                  <div class="flex flex-row mb-8">
                    <p class="font-14 m-0 w-75">
                      Does the loadcell show signs of excessive wear?
                    </p>
                    <mat-icon
                      class="check-mark"
                      *ngIf="model.form10a.excessiveWear == YesNoNa.Yes"
                      >check</mat-icon
                    >
                    <mat-icon
                      class="cross"
                      *ngIf="model.form10a.excessiveWear == YesNoNa.No"
                      >close</mat-icon
                    >
                    <h3 *ngIf="model.form10a.excessiveWear == YesNoNa.NA">N/A</h3>
                  </div>
                  <div class="flex flex-row mb-8">
                    <p class="font-14 m-0 w-75">
                      Does the amplifier function correctly on a dummy bridge?
                    </p>
                    <mat-icon
                      class="check-mark"
                      *ngIf="model.form10a.amplifierFunctionCorrectly == YesNoNa.Yes"
                      >check</mat-icon
                    >
                    <mat-icon
                      class="cross"
                      *ngIf="model.form10a.amplifierFunctionCorrectly == YesNoNa.No"
                      >close</mat-icon
                    >
                    <h3 *ngIf="model.form10a.amplifierFunctionCorrectly == YesNoNa.NA">
                      N/A
                    </h3>
                  </div>
                  <div class="flex flex-row mb-8">
                    <p class="font-14 m-0 w-75">Is the connector in good condition?</p>
                    <mat-icon
                      class="check-mark"
                      *ngIf="model.form10a.connectorGoodCondition == YesNoNa.Yes"
                      >check</mat-icon
                    >
                    <mat-icon
                      class="cross"
                      *ngIf="model.form10a.connectorGoodCondition == YesNoNa.No"
                      >close</mat-icon
                    >
                    <h3 *ngIf="model.form10a.connectorGoodCondition == YesNoNa.NA">
                      N/A
                    </h3>
                  </div>
                  <div class="flex flex-row mb-8">
                    <p class="font-14 m-0 w-75">
                      Does the loadcell show any signs of water ingress?
                    </p>
                    <mat-icon
                      class="check-mark"
                      *ngIf="model.form10a.waterIngress == YesNoNa.Yes"
                      >check</mat-icon
                    >
                    <mat-icon
                      class="cross"
                      *ngIf="model.form10a.waterIngress == YesNoNa.No"
                      >close</mat-icon
                    >
                    <h3 *ngIf="model.form10a.waterIngress == YesNoNa.NA">N/A</h3>
                  </div>
                  <div class="flex flex-row mb-8">
                    <p class="font-14 m-0 w-75">
                      Does the cable have continuity throughout?
                    </p>
                    <mat-icon
                      class="check-mark"
                      *ngIf="model.form10a.cableContinuity == YesNoNa.Yes"
                      >check</mat-icon
                    >
                    <mat-icon
                      class="cross"
                      *ngIf="model.form10a.cableContinuity == YesNoNa.No"
                      >close</mat-icon
                    >
                    <h3 *ngIf="model.form10a.cableContinuity == YesNoNa.NA">N/A</h3>
                  </div>
                  <div class="flex flex-row mb-8">
                    <p class="font-14 m-0 w-75">
                      Is the loadcell damaged, bent or deformed?
                    </p>
                    <mat-icon
                      class="check-mark"
                      *ngIf="model.form10a.loadcellDamaged == YesNoNa.Yes"
                      >check</mat-icon
                    >
                    <mat-icon
                      class="cross"
                      *ngIf="model.form10a.loadcellDamaged == YesNoNa.No"
                      >close</mat-icon
                    >
                    <h3 *ngIf="model.form10a.loadcellDamaged == YesNoNa.NA">N/A</h3>
                  </div>
                </div>
              </div>

              <div
                class="flex flex-row underlined justify-between items-center mx-32"
                (click)="toggleCollapseBridgeLeg()"
              >
                <h4 class="cursor-pointer py-8 m-0">Bridge leg resistances:</h4>
                <mat-icon *ngIf="bridgeLegExpanded">expand_more</mat-icon>
                <mat-icon *ngIf="!bridgeLegExpanded">chevron_right</mat-icon>
              </div>
              <div *ngIf="bridgeLegExpanded">
                <p class="font-14 mx-32 my-8">
                  {{ model.form10a.bridgeLegResistances }}
                </p>
              </div>

              <div
                class="flex flex-row underlined justify-between items-center mx-32"
                (click)="toggleCollapseConnector()"
              >
                <h4 class="cursor-pointer py-8 m-0">Connector pin out (s):</h4>
                <mat-icon *ngIf="connectorExpanded">expand_more</mat-icon>
                <mat-icon *ngIf="!connectorExpanded">chevron_right</mat-icon>
              </div>
              <div *ngIf="connectorExpanded">
                <p class="font-14 mx-32 my-8">{{ model.form10a.connectorPinOuts }}</p>
              </div>

              <div class="flex flex-row items-center mx-16 my-16">
                <div class="flex flex-col mx-16">
                  <h4>Drift test results</h4>
                  <div class="flex flex-row">
                    <p class="bigger info-title font-14 m-0">Initial Output:</p>
                    <p class="font-14 ml-8 m-0">{{ model.form10a.initalOutput }}</p>
                  </div>
                  <div class="flex flex-row">
                    <p class="bigger info-title font-14 m-0">End Output:</p>
                    <p class="font-14 ml-8 m-0">{{ model.form10a.endOutput }}</p>
                  </div>
                  <div class="flex flex-row">
                    <p class="bigger info-title font-14 m-0">Time tested for:</p>
                    <p class="font-14 ml-8 m-0">{{ model.form10a.timeTested }}</p>
                  </div>
                  <div class="flex flex-row">
                    <p class="bigger info-title font-14 m-0">+/- Output difference:</p>
                    <p class="font-14 ml-8 m-0">{{ model.form10a.outputDifference }}</p>
                  </div>
                </div>
              </div>

              <div class="pt-6"></div>
            </div>

            <!-- Calibration Test Results -->
            <div *ngIf="selectedTab == Tab.Calibration" class="flex flex-col w-full">
              <mat-label class="w-full text-xl px-32">Calibrations</mat-label>
              <div
                class="flex flex-row items-end justify-between px-32 w-full"
              >
                <ng-container
                  *ngFor="let calibration of model.calibrations; let i = index"
                >
                  <h4
                    class="underlined cursor-pointer p-8 m-0"
                    [class]="{ selectedTab: selectedCalibrationIndex == i }"
                    (click)="selectCalibration(i)"
                  >
                    {{
                      calibration.isPreCalibration
                        ? "Pre."
                        : !calibration.isComplete ? "Incomplete."
                        : (model.form10a.requiresPreCalibration ? i : i + 1) + "."
                    }}
                  </h4>
                </ng-container>
                <div
                  class="flex button-container justify-end items-end w-full ml-16 -mt-9 mb-6"
                >
                  <button
                    *ngIf="calibrationHasPressureTest()"
                    mat-flat-button
                    color="primary"
                    class="mr-16"
                    (click)="openPressureTestDialog()"
                  >
                    Pressure Test Certificate
                  </button>
                  <button
                    mat-flat-button
                    color="primary"
                    class="mr-16"
                    (click)="openExaminationReportDialog()"
                  >
                    Examination Report
                  </button>
                  <button
                    mat-flat-button
                    color="primary"
                    (click)="openPrintDialog()"
                  >
                    Calibration Certificate
                  </button>
                </div>
              </div>
                <!-- *ngIf="isAdmin" -->
              <div class="flex flex-row justify-end items-center px-32 w-full -mt-2">
                <p
                  class="clickable pr-8 mb-0"
                  (click)="editCalibration(selectedCalibrationIndex)"
                >
                  Edit Calibration
                </p>
                <mat-icon
                  [svgIcon]="'heroicons_solid:pencil'"
                  class="pointer icon-size-5"
                  (click)="editCalibration(selectedCalibrationIndex)"
                >
                </mat-icon>
              </div>

              <div *ngIf="hasUnsyncedCalibration(selectedCalibrationIndex)" class="flex flex-row justify-end items-center mt-4 px-32 w-full">
                <p class="clickable pr-8 mb-0" (click)="saveOfflineCalibration(selectedCalibrationIndex)">
                  Sync Offline Calibration
                </p>
                <mat-icon
                  [svgIcon]="'custom:sync'"
                  class="pointer icon-size-5"
                  (click)="saveOfflineCalibration(selectedCalibrationIndex)"
                >
                </mat-icon>
              </div>

              <ng-container
                *ngFor="let calibration of model.calibrations; let i = index"
              >
                <ng-container *ngIf="selectedCalibrationIndex == i">
                  <div class="flex flex-row justify-between mx-16 my-16">
                    <div class="flex flex-col mx-16 w-50">
                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4">Booking ref:</p>
                        <p class="font-14 m-0 ml-8 mb-4">
                          {{ calibration.bookingRef }}
                        </p>
                      </div>

                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4">
                          TW3.0 Link unit S/N:
                        </p>
                        <p class="font-14 m-0 ml-8 mb-4">
                          {{ calibration.linkUnit }}
                        </p>
                      </div>
                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4">TW3.0 HHD S/N:</p>
                        <p class="font-14 m-0 ml-8 mb-4">
                          {{ calibration.handheld }}
                        </p>
                      </div>
                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4 w-75">
                          Pressure test:
                        </p>
                        <mat-icon
                          class="check-mark"
                          *ngIf="calibration.pressureTestResult == 0"
                          >check</mat-icon
                        >
                        <mat-icon
                          class="cross"
                          *ngIf="calibration.pressureTestResult == 1"
                          >close</mat-icon
                        >
                        <h3 *ngIf="calibration.pressureTestResult == 2">N/A</h3>
                      </div>
                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4">
                          Radio firmware:
                        </p>
                        <p class="font-14 m-0 ml-8 mb-4">
                          {{ calibration.radioFirmware }}
                        </p>
                      </div>
                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4">
                          Link unit firmware:
                        </p>
                        <p class="font-14 m-0 ml-8 mb-4">
                          {{ calibration.linkUnitFirmware }}
                        </p>
                      </div>
                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4">
                          handheld firmware:
                        </p>
                        <p class="font-14 m-0 ml-8 mb-4">
                          {{ calibration.handheldFirmware }}
                        </p>
                      </div>
                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4">
                          Calibration Block{{calibration?.blocks?.length > 1 ? 's' : ''}}:
                        </p>
                        <p class="font-14 m-0 ml-8 mb-4">
                          {{ getBlockNames(calibration.blocks) }}
                        </p>
                      </div>
                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4">Block ID{{calibration?.blocks?.length > 1 ? 's' : ''}}:</p>
                        <p class="font-14 m-0 ml-8 mb-4">
                          {{ getBlockIds(calibration.blocks) }}
                        </p>
                      </div>
                    </div>

                    <!-- right side -->
                    <div class="flex flex-col mx-16 w-50">
                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4">WLL:</p>
                        <p class="font-14 m-0 ml-8 mb-4">{{ calibration.swl }}</p>
                      </div>
                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4">
                          MV / V Output at WLL:
                        </p>
                        <p class="font-14 m-0 ml-8 mb-4">{{ calibration.output }}</p>
                      </div>
                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4">
                          Pressure rating:
                        </p>
                        <p class="font-14 m-0 ml-8 mb-4">
                          {{ calibration.pressureRating }}
                        </p>
                      </div>
                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4">
                          Pressure Gauge:
                        </p>
                        <p class="font-14 m-0 ml-8 mb-4">
                          {{ calibration?.pressureTestMachine?.name ?? "N/A" }}
                        </p>
                      </div>
                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4">Proof load:</p>
                        <p class="font-14 m-0 ml-8 mb-4">
                          {{ calibration.proofLoad * 100 + "%" }}
                        </p>
                      </div>
                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4">Range:</p>
                        <p class="font-14 m-0 ml-8 mb-4">{{ calibration.range }}</p>
                      </div>
                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4">
                          Element resistance:
                        </p>
                        <p class="font-14 m-0 ml-8 mb-4">
                          {{ calibration.resistance }}
                        </p>
                      </div>
                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4">
                          Multimeter S/N:
                        </p>
                        <p class="font-14 m-0 ml-8 mb-4">
                          {{ calibration.multimeter }}
                        </p>
                      </div>
                      <div class="flex flex-row">
                        <p class="bigger info-title font-14 m-0 mb-4">Test Machine:</p>
                        <p class="font-14 m-0 ml-8 mb-4">
                          {{ getMachineRatingText(calibration.machineRating) }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <mat-divider class="mx-16"></mat-divider>

                  <!-- 1st result set -->
                  <div
                    *ngIf="calibration?.additionalResultsSet"
                    class="flex flex-row justify-between items-center mx-16 my-16"
                  >
                    <h4 class="font-14 my-0 mx-16 mb-4  text-decoration-underline">
                      1st Result Set
                    </h4>
                  </div>

                  <div
                    class="flex flex-row justify-between items-center mx-16 my-16"
                  >
                    <div class="flex flex-col mx-16 w-50">
                      <h4 class="font-14 m-0 mb-4">Cal equipment</h4>
                      <p
                        *ngFor="let equipment of calibration.equipmentList"
                        class="font-14 m-0 mb-4"
                      >
                        {{ equipment.machine?.name }}
                      </p>
                    </div>

                    <div class="flex flex-col mx-16 w-50">
                      <h4 class="font-14 m-0 mb-4">Serial Number</h4>
                      <p
                        *ngFor="let equipment of calibration.equipmentList"
                        class="font-14 m-0 mb-4"
                      >
                        {{ equipment.machine?.serialNumber }}
                      </p>
                    </div>
                  </div>

                  <div class="flex flex-row items-center mx-16">
                    <div class="flex flex-col mx-16">
                      <h4 class="font-14 m-0 mb-4">Table of results</h4>
                    </div>
                  </div>

                  <div class="flex flex-row justify-between mx-16">
                    <div class="flex flex-row mx-16 w-50">
                      <p class="bigger info-title font-14 m-0 mb-4">Measured in:</p>
                      <p class="font-14 m-0 ml-8 mb-4">
                        {{ calibration.measurementResponse.name }}
                      </p>
                    </div>

                    <div class="flex flex-row mx-16 w-50">
                      <p class="bigger info-title font-14 m-0 mb-4">Resolution:</p>
                      <p class="font-14 m-0 ml-8 mb-4">
                        {{ calibration.resolution }}
                      </p>
                    </div>
                  </div>

                  <div class="flex flex-row justify-between mx-16">
                    <div class="flex flex-row mx-16 w-50">
                      <p class="bigger info-title font-14 m-0 mb-4">Calibration in:</p>
                      <p class="font-14 m-0 ml-8 mb-4">
                        {{ calibration.isCompression == null ? "Tension & Compression" : calibration.isCompression ? "Compression" : "Tension" }}
                      </p>
                    </div>

                    <div class="flex flex-row mx-16 w-50"></div>
                  </div>

                  <div
                    class="flex flex-row justify-between items-center mx-16 my-16"
                  >
                    <div class="flex flex-col mx-16">
                      <div class="flex flex-row">
                        <h4 class="font-14 m-0">Machine Readings</h4>
                      </div>
                      <div class="flex flex-col justify-center">
                        <p
                          *ngFor="let result of calibration.resultList"
                          class="font-14 run-value-alignment m-0"
                        >
                          {{
                            result.machineReadings != null
                              ? getScaledValue(result.machineReadings, calibration)
                              : null
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="flex flex-col mx-16">
                      <div class="flex flex-row">
                        <h4 class="font-14 m-0">Desired</h4>
                      </div>
                      <div class="flex flex-col justify-center">
                        <p
                          *ngFor="let result of calibration.resultList"
                          class="font-14 run-value-alignment m-0"
                        >
                          {{
                            result.desired != null
                              ? getScaledValue(result.desired, calibration)
                              : null
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="flex flex-col mx-16">
                      <div class="flex flex-row">
                        <h4 class="font-14 m-0">Run 1</h4>
                      </div>
                      <div class="flex flex-col justify-center">
                        <p
                          *ngFor="let result of calibration.resultList"
                          class="font-14 run-value-alignment m-0"
                        >
                          {{
                            result.run1 != null
                              ? getScaledValue(result.run1, calibration)
                              : null
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="flex flex-col mx-16">
                      <div class="flex flex-row">
                        <h4 class="font-14 m-0">Run 2</h4>
                      </div>
                      <div class="flex flex-col justify-center">
                        <p
                          *ngFor="let result of calibration.resultList"
                          class="font-14 run-value-alignment m-0"
                        >
                          {{
                            result.run2 != null
                              ? getScaledValue(result.run2, calibration)
                              : null
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="flex flex-col mx-16">
                      <div class="flex flex-row">
                        <h4 class="font-14 m-0">Run 3</h4>
                      </div>
                      <div class="flex flex-col justify-center">
                        <p
                          *ngFor="let result of calibration.resultList"
                          class="font-14 run-value-alignment m-0"
                        >
                          {{
                            result.run3 != null
                              ? getScaledValue(result.run3, calibration)
                              : null
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="flex flex-col mx-16">
                      <div class="flex flex-row">
                        <h4 class="font-14 m-0">Run 4</h4>
                      </div>
                      <div class="flex flex-col justify-center">
                        <p
                          *ngFor="let result of calibration.resultList"
                          class="font-14 run-value-alignment m-0"
                        >
                          {{
                            result.run4 != null
                              ? getScaledValue(result.run4, calibration)
                              : null
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="flex flex-col mx-16">
                      <div class="flex flex-row">
                        <h4 class="font-14 m-0">Run 5</h4>
                      </div>
                      <div class="flex flex-col justify-center">
                        <p
                          *ngFor="let result of calibration.resultList"
                          class="font-14 run-value-alignment m-0"
                        >
                          {{
                            result.run5 != null
                              ? getScaledValue(result.run5, calibration)
                              : null
                          }}
                        </p>
                      </div>
                    </div>

                    <div class="flex flex-col mx-16">
                      <div class="flex flex-row">
                        <h4 class="font-14 m-0">Error</h4>
                      </div>
                      <div class="flex flex-col justify-center">
                        <p
                          *ngFor="let result of calibration.resultList"
                          class="font-14 run-value-alignment m-0"
                        >
                          {{
                            (result.error ?? 0).toFixed(2) + "%"
                          }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <mat-divider class="mx-16"></mat-divider>

                  <!-- 2st result set -->
                  <ng-container *ngIf="calibration?.additionalResultsSet">
                    <div
                      class="flex flex-row justify-between items-center mx-16 my-16"
                    >
                      <h4
                        class="font-14 my-0 mx-16 mb-4  text-decoration-underline"
                      >
                        2nd Result Set
                      </h4>
                    </div>

                    <div
                      class="flex flex-row justify-between items-center mx-16 my-16"
                    >
                      <div class="flex flex-col mx-16 w-50">
                        <h4 class="font-14 m-0 mb-4">Cal equipment</h4>
                        <p
                          *ngFor="let equipment of calibration.additionalEquipmentList"
                          class="font-14 m-0 mb-4"
                        >
                          {{ equipment.machine?.name }}
                        </p>
                      </div>

                      <div class="flex flex-col mx-16 w-50">
                        <h4 class="font-14 m-0 mb-4">Serial Number</h4>
                        <p
                          *ngFor="let equipment of calibration.additionalEquipmentList"
                          class="font-14 m-0 mb-4"
                        >
                          {{ equipment.machine?.serialNumber }}
                        </p>
                      </div>
                    </div>

                    <div class="flex flex-row items-center mx-16">
                      <div class="flex flex-col mx-16">
                        <h4 class="font-14 m-0 mb-4">Table of results</h4>
                      </div>
                    </div>

                    <div class="flex flex-row justify-between mx-16">
                      <div class="flex flex-row mx-16 w-50">
                        <p class="bigger info-title font-14 m-0 mb-4">Measured in:</p>
                        <p class="font-14 m-0 ml-8 mb-4">
                          {{ calibration.additionalMeasurementResponse.name }}
                        </p>
                      </div>

                      <div class="flex flex-row mx-16 w-50">
                        <p class="bigger info-title font-14 m-0 mb-4">Resolution:</p>
                        <p class="font-14 m-0 ml-8 mb-4">
                          {{ calibration.additionalResolution }}
                        </p>
                      </div>
                    </div>

                    <div class="flex flex-row justify-between mx-16">
                      <div class="flex flex-row mx-16 w-50">
                        <p class="bigger info-title font-14 m-0 mb-4">Calibration in:</p>
                        <p class="font-14 m-0 ml-8 mb-4">
                          {{ calibration.additionalIsCompression == null ? "Tension & Compression" : calibration.additionalIsCompression ? "Compression" : "Tension" }}
                        </p>
                      </div>

                      <div class="flex flex-row mx-16 w-50"></div>
                    </div>

                    <div
                      class="flex flex-row justify-between items-center mx-16 my-16"
                    >
                      <div class="flex flex-col mx-16">
                        <div class="flex flex-row">
                          <h4 class="font-14 m-0">Machine Readings</h4>
                        </div>
                        <div class="flex flex-col justify-center">
                          <p
                            *ngFor="let result of calibration.additionalResultList"
                            class="font-14 run-value-alignment m-0"
                          >
                            {{
                              result.machineReadings != null
                                ? getScaledValue(
                                    result.machineReadings,
                                    calibration,
                                    true
                                  )
                                : null
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="flex flex-col mx-16">
                        <div class="flex flex-row">
                          <h4 class="font-14 m-0">Desired</h4>
                        </div>
                        <div class="flex flex-col justify-center">
                          <p
                            *ngFor="let result of calibration.additionalResultList"
                            class="font-14 run-value-alignment m-0"
                          >
                            {{
                              result.desired != null
                                ? getScaledValue(result.desired, calibration, true)
                                : null
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="flex flex-col mx-16">
                        <div class="flex flex-row">
                          <h4 class="font-14 m-0">Run 1</h4>
                        </div>
                        <div class="flex flex-col justify-center">
                          <p
                            *ngFor="let result of calibration.additionalResultList"
                            class="font-14 run-value-alignment m-0"
                          >
                            {{
                              result.run1 != null
                                ? getScaledValue(result.run1, calibration, true)
                                : null
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="flex flex-col mx-16">
                        <div class="flex flex-row">
                          <h4 class="font-14 m-0">Run 2</h4>
                        </div>
                        <div class="flex flex-col justify-center">
                          <p
                            *ngFor="let result of calibration.additionalResultList"
                            class="font-14 run-value-alignment m-0"
                          >
                            {{
                              result.run2 != null
                                ? getScaledValue(result.run2, calibration, true)
                                : null
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="flex flex-col mx-16">
                        <div class="flex flex-row">
                          <h4 class="font-14 m-0">Run 3</h4>
                        </div>
                        <div class="flex flex-col justify-center">
                          <p
                            *ngFor="let result of calibration.additionalResultList"
                            class="font-14 run-value-alignment m-0"
                          >
                            {{
                              result.run3 != null
                                ? getScaledValue(result.run3, calibration, true)
                                : null
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="flex flex-col mx-16">
                        <div class="flex flex-row">
                          <h4 class="font-14 m-0">Run 4</h4>
                        </div>
                        <div class="flex flex-col justify-center">
                          <p
                            *ngFor="let result of calibration.additionalResultList"
                            class="font-14 run-value-alignment m-0"
                          >
                            {{
                              result.run4 != null
                                ? getScaledValue(result.run4, calibration, true)
                                : null
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="flex flex-col mx-16">
                        <div class="flex flex-row">
                          <h4 class="font-14 m-0">Run 5</h4>
                        </div>
                        <div class="flex flex-col justify-center">
                          <p
                            *ngFor="let result of calibration.additionalResultList"
                            class="font-14 run-value-alignment m-0"
                          >
                            {{
                              result.run5 != null
                                ? getScaledValue(result.run5, calibration, true)
                                : null
                            }}
                          </p>
                        </div>
                      </div>

                      <div class="flex flex-col mx-16">
                        <div class="flex flex-row">
                          <h4 class="font-14 m-0">Error</h4>
                        </div>
                        <div class="flex flex-col justify-center">
                          <p
                            *ngFor="let result of calibration.additionalResultList"
                            class="font-14 run-value-alignment m-0"
                          >
                            {{
                              (result.error ?? 0).toFixed(2) + "%"
                            }}
                          </p>
                        </div>
                      </div>
                    </div>

                    <mat-divider class="mx-16"></mat-divider>
                  </ng-container>

                  <div class="flex flex-row items-center mx-16 my-16">
                    <div class="flex flex-col mx-16">
                      <div class="flex flex-row">
                        <p class="font-14 m-0">Adjustments required?:</p>
                        <p *ngIf="calibration.adjustment == 0" class="font-14 ml-8 m-0">
                          Yes
                        </p>
                        <p *ngIf="calibration.adjustment == 1" class="font-14 ml-8 m-0">
                          No
                        </p>
                        <p *ngIf="calibration.adjustment == 2" class="font-14 ml-8 m-0">
                          Unable to adjust
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="flex flex-row items-center mx-16 my-16">
                    <div class="flex flex-col mx-16">
                      <div class="flex flex-row">
                        <p class="font-14 m-0">Does it meet manufacturers spec?:</p>
                        <p
                          *ngIf="calibration.manuSpec == ManufacturerSpec.Yes"
                          class="font-14 m-0 ml-8"
                        >
                          Yes
                        </p>
                        <p
                          *ngIf="calibration.manuSpec == ManufacturerSpec.No"
                          class="font-14 m-0 ml-8"
                        >
                          No
                        </p>
                        <p
                          *ngIf="calibration.manuSpec == ManufacturerSpec.Unknown"
                          class="font-14 m-0 ml-8"
                        >
                          Unknown
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="flex flex-row justify-between mx-16">
                    <div class="flex flex-row mx-16 w-50">
                      <p class="font-14 m-0 mb-4">signature:</p>
                      <img src="{{ calibration?.signature }}" />
                    </div>

                    <div class="flex flex-row mx-16 w-50">
                      <p class="font-14 m-0 mb-4">Date:</p>
                      <p class="font-14 m-0 ml-8 mb-4">
                        {{ calibration.date | date: "d/M/YYYY" }}
                      </p>
                    </div>
                  </div>

                  <div class="flex flex-row justify-start mx-16">
                    <div class="flex flex-row mx-16 w-50">
                      <p class="font-14 m-0 mb-4">Send Calibration Reminder Email?:</p>
                      <mat-slide-toggle
                        class="ml-8"
                        [ngValue]="calibration?.sendReminder"
                        (change)="updateSendReminder(calibration, $event)"
                      ></mat-slide-toggle>
                    </div>
                  </div>
                </ng-container>
              </ng-container>

              <div class="pt-6"></div>
            </div>

            <!-- Dispatch Notes (Documents) Tab -->
            <div *ngIf="selectedTab == Tab.DispatchNotes" class="flex flex-col w-full px-32">

              <!-- Attachments -->
              <div class="flex flex-row justify-between mb-6 gap-4">
                <mat-label class="w-full text-xl">Documents</mat-label>
                <button
                  mat-flat-button
                  color="primary"
                  (click)="openFileUpload()">
                  <div class="mx-3 flex gap-2 items-center">
                    <mat-icon [svgIcon]="'mat_outline:file_upload'"></mat-icon>
                    <span>Upload</span>
                  </div>
                </button>
                <button
                  mat-flat-button
                  color="primary"
                  (click)="openImageCapture()">
                  <div class="mx-3 flex gap-2 items-center">
                    <mat-icon [svgIcon]="'heroicons_outline:camera'"></mat-icon>
                    <span>Take Photo</span>
                  </div>
                </button>
              </div>

              <div class="w-full flex flex-row flex-wrap gap-4">
                  <!-- Files -->
                  <ng-container *ngIf="attachments?.length > 0">
                      <ng-container *ngFor="let file of attachments">
                        <div class="bg-[#f8f8f8] rounded-xl p-[1rem] flex flex-col gap-2 relative min-w-[180px] max-w-[220px]">
                            <!-- Icons -->
                            <mat-icon *ngIf="getFileCategory(file.type) == 'document'" class="icon-size-7 text-red-600" [svgIcon]="'feather:file-text'"></mat-icon>
                            <mat-icon *ngIf="getFileCategory(file.type) == 'image'" class="icon-size-7 text-blue-600" [svgIcon]="'feather:image'"></mat-icon>
                            <mat-icon *ngIf="getFileCategory(file.type) == 'spreadsheet'" class="icon-size-7 text-green-600" [svgIcon]="'heroicons_outline:table-cells'"></mat-icon>
                            
                            <mat-icon *ngIf="!isBasic"
                              class="bg-white text-[var(--dlm-red)] rounded-full icon-size-6 absolute cursor-pointer top-[5px] right-[5px]"
                              [svgIcon]="'heroicons_solid:x-circle'"
                              matTooltip="Delete File"
                              (click)="deleteFile(file, $event)">
                            </mat-icon>
                            <mat-icon *ngIf="!isBasic"
                              class="bg-white text-[var(--dlm-green)] rounded-full icon-size-6 absolute cursor-pointer bottom-[5px] right-[5px]"
                              [svgIcon]="'mat_solid:download_for_offline'"
                              matTooltip="Download File"
                              (click)="download(file)">
                            </mat-icon>

                            <!-- Details -->
                            <div class="flex flex-col">
                              <span>{{file.name}}</span>
                              <span class="text-sm mt-1">{{file.type.toUpperCase().replace('.', '')}} - {{getFileSizeText(file.size)}}</span>
                              <span class="text-sm">{{file.createdUTC | date:'dd/MM/yyyy'}}</span>
                            </div>
                        </div>
                      </ng-container>
                  </ng-container>
              </div>

              <div class="pt-6"></div>
            </div>

            <!-- Activity Log / History Tab -->
            <div *ngIf="selectedTab == Tab.History" class="flex flex-col w-full px-32">
              <mat-label class="w-full text-xl">History</mat-label>
              <ng-container *ngFor="let history of model?.loadcell?.history">
                  <div class="italic whitespace-pre-line mt-6" [innerHTML]="history.description">
                  </div>
                  <div class="text-sm mt-2" style="color: black;">
                      {{ history.timeStamp | date:'d MMM yyyy, h:mm:ss a' }}
                  </div>
              </ng-container>
            </div>

            <!-- Email Trail Tab -->
            <div *ngIf="selectedTab == Tab.Emails" class="flex flex-col w-full px-32">
              <mat-label class="w-full text-xl">Email Trail</mat-label>

              <div class="flex flex-col gap-4 divide-y w-full">
                  <ng-container *ngFor="let email of model?.loadcell?.emailTrails; let first = first;">
                      <div class="flex flex-row gap-4 w-full pt-6">
                          <div class="flex flex-col gap-2">
                              <span>Subject:</span>
                              <span>Date:</span>
                              <span>From:</span>
                              <span>To:</span>
                              <span>Body:</span>
                          </div>

                          <div class="flex flex-col gap-2 min-w-0 flex-1">
                              <span>{{email.subject}}</span>
                              <span>{{email.date | date:'d MMM yyyy HH:mm'}}</span>
                              <span>{{email.fromAddress}}</span>
                              <span>{{email.toAddress}}</span>
                              <div class="whitespace-wrap" [innerHTML]="email.body"></div>
                          </div>
                      </div>
                  </ng-container>
              </div>

            </div>

          </div>

        </mat-drawer-content>

      </mat-drawer-container>
    </div>

  </div>

</ng-container>
